import React, { Component } from 'react';
import styled from 'styled-components';

const ErrorSvgStyled = styled.span`
  position: relative;
  display: inline-block;
  width: 100%;
  padding-bottom: 100%; // viewBox height / viewBox width x 100%

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

class ErrorSvg extends Component {
  render() {
    return (
      <ErrorSvgStyled>
        <svg
          viewBox="0 0 74 74"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon id="path-1" points="0 74 74 74 74 0 0 0" />
          </defs>
          <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            transform="translate(-274.000000, -217.000000)"
          >
            <g transform="translate(274.000000, 217.000000)">
              <g>
                <path
                  d="M37,2 C17.7012121,2 2,17.7012121 2,37 C2,56.2987879 17.7012121,72 37,72 C56.2987879,72 72,56.2987879 72,37 C72,17.7012121 56.2987879,2 37,2"
                  stroke="#FFFFFF"
                  strokeWidth="4"
                  fill="#2B4D8C"
                />
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1" />
                </mask>
                <g />
                <polygon
                  fill="#FFFFFF"
                  mask="url(#mask-2)"
                  points="32.116 43.894 40.116 43.894 40.116 16.044 32.116 16.044"
                />
                <path
                  d="M41.1162,54.337 C41.1162,57.099 38.8782,59.337 36.1162,59.337 C33.3562,59.337 31.1162,57.099 31.1162,54.337 C31.1162,51.577 33.3562,49.337 36.1162,49.337 C38.8782,49.337 41.1162,51.577 41.1162,54.337"
                  fill="#FFFFFF"
                  mask="url(#mask-2)"
                />
              </g>
            </g>
          </g>
        </svg>
      </ErrorSvgStyled>
    );
  }
}

export default ErrorSvg;



/** WEBPACK FOOTER **
 ** ./src/components/LeadsForm/ErrorSvg.js
 **/